import React, { useState } from 'react';
import { Move, getMediaUrl } from '../services/api';
import DemonstrationUploadModal from './DemonstrationUploadModal';
import MediaDialog, { ShortcutHint } from './MediaDialog';

interface VideoModalProps {
  move: Move;
  onClose: () => void;
}

const VideoModal: React.FC<VideoModalProps> = ({ move, onClose }) => {
  const [showUploadModal, setShowUploadModal] = useState(false);

  const defaultVideo = move.videos?.find(video => video.isDefault) || move.videos?.[0];
  const videoUrl = defaultVideo?.videoUrl || move.videoUrl || '';
  const thumbnail = defaultVideo?.thumbnail || move.thumbnail;

  const tags = [move.style?.name, move.skillLevel?.name, move.instructor?.name].filter(Boolean);

  return (
    <>
      <MediaDialog
        src={getMediaUrl(videoUrl)}
        poster={thumbnail ? getMediaUrl(thumbnail) : undefined}
        title={move.title}
        onClose={onClose}
        // Hand Escape/focus-trap/shortcuts over to the upload modal while it's open
        active={!showUploadModal}
      >
        {move.variationDescription && (
          <span className="media-dialog-eyebrow">Variation · {move.variationDescription}</span>
        )}
        <h2>{move.title}</h2>
        {move.description && <p>{move.description}</p>}
        {tags.length > 0 && (
          <div className="media-dialog-tags">
            {tags.map((t) => <span key={t}>{t}</span>)}
          </div>
        )}
        <div className="media-dialog-actions">
          <button type="button" className="btn btn-primary" onClick={() => setShowUploadModal(true)}>
            Demonstrate this move
          </button>
        </div>
        <ShortcutHint />
      </MediaDialog>

      {showUploadModal && (
        <DemonstrationUploadModal
          move={move}
          onClose={() => setShowUploadModal(false)}
          onSuccess={() => {}}
        />
      )}
    </>
  );
};

export default VideoModal;
